var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import Modal from "../../../../../Layout/Modal";
import { Translate } from "../../../../../I18N";
import { MultiSelect } from "../../../../../Forms";

import Icons from "../../../../../Templates/components/Icons";


const SUPPORTED_PROPERTIES = ['text', 'numeric', 'date'];









const ExtractorModal = ({
  isOpen,
  onClose,
  onAccept,
  templates,
  extractor
}) => {
  const [name, setName] = useState('');
  const [values, setValues] = useState([]);
  const [isEditing, setEditing] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (extractor) {
      setEditing(true);
      setName(extractor.name);
      const initialValues = extractor.templates.map(
        (template) => `${template}-${extractor.property}`
      );
      setValues(initialValues);
    } else {
      setEditing(false);
    }
  }, [extractor]);

  const filter = values.length ? values[0].split('-', 2)[1] : null;
  const options = templates.map((template) => {var _template$properties, _template$_id2;return {
      label: template.name,
      id: template._id,
      value: template._id,
      options: (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.
      filter((prop) => !filter || prop.name === filter).
      map((prop) => {var _template$_id;return {
          label: prop.label,
          value: `${(_template$_id = template._id) === null || _template$_id === void 0 ? void 0 : _template$_id.toString()}-${prop.name}`,
          type: prop.type,
          icon: { type: 'Icons', _id: Icons[prop.type] }
        };}).
      filter(({ type }) => SUPPORTED_PROPERTIES.includes(type)).
      concat(
        !filter || filter === 'title' ?
        [
        {
          label: 'Title',
          value: `${(_template$_id2 = template._id) === null || _template$_id2 === void 0 ? void 0 : _template$_id2.toString()}-title`,
          type: 'text',
          icon: { type: 'Icons', _id: Icons.text }
        }] :

        []
      )
    };});

  const handleClose = () => {
    setEditing(false);
    setName('');
    setValues([]);
    setIsDisabled(false);
    onClose();
  };

  // eslint-disable-next-line max-statements
  const handleSubmit = (submittedName, submitedValues) => {
    if (!submittedName.length) {
      setError(true);
      return;
    }

    setEditing(false);
    setIsDisabled(true);
    const result = submitedValues.length ?
    {
      _id: undefined,
      name: submittedName,
      property: submitedValues[0].split('-', 2)[1],
      templates: submitedValues.map((value) => value.split('-', 2)[0])
    } :
    null;

    if (isEditing && result && extractor) {
      result._id = extractor._id;
    }

    if (result === null) {
      handleClose();
    } else {
      onAccept(result);
      handleClose();
    }
  };

  const onAllTemplatedCheckboxChanged = () => {
    const properties = new Set();
    const newValues = [];

    values.forEach((value) => {
      properties.add(value.split('-')[1]);
    });

    const validTemplateIds = templates.
    filter((template) => {
      const isTitle = properties.has('title');

      if (isTitle) return true;

      const hasMatchingProperty = template.properties.filter((property) =>
      properties.has(property.name)
      ).length;

      return hasMatchingProperty > 0;
    }).
    map((template) => template._id);

    validTemplateIds.forEach((id) => {
      const arrProps = Array.from(properties);
      arrProps.forEach((prop) => {
        newValues.push(`${id}-${prop}`);
      });
    });

    setValues(newValues);
  };

  return /*#__PURE__*/(
    _jsx(Modal, { isOpen: isOpen, type: "content", className: "extractor-creation-modal" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "extractor-label" }, void 0,
    isEditing ? /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Edit Extractor") : /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Create Extractor")

    ), /*#__PURE__*/
    _jsx("div", { className: "all-templates-button" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn",
      onClick: onAllTemplatedCheckboxChanged,
      disabled: !values.length }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "From all templates")
    )
    )
    ), /*#__PURE__*/
    _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
    _jsx("input", {
      value: name,
      type: "text",
      className: "form-control extractor-name-input",
      onChange: (event) => {
        setName(event.target.value);
        setError(false);
      },
      placeholder: "Extractor name" }
    ),
    error && /*#__PURE__*/
    _jsx("div", { className: "tw-content" }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "block mt-1 text-sm font-medium text-error-700" }, void 0, "This field is required"

    )
    ), /*#__PURE__*/

    _jsx("div", { className: "property-selection" }, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      className: "ix-extraction-multiselect",
      value: values,
      onChange: setValues,
      options: options,
      optionsToShow: 20,
      topLevelSelectable: false }
    )
    ), /*#__PURE__*/
    _jsx("span", { className: "left" }, void 0, "* ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Only text, number and date properties are currently supported")
    )
    ), /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "extractor-footer" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn btn-default btn-extra-padding action-button",
      onClick: handleClose }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn btn-default action-button btn-extra-padding",
      onClick: () => handleSubmit(name, values),
      disabled: isDisabled }, void 0,

    isEditing ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Save") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add")
    )
    )
    )
    ));

};

export { ExtractorModal };